import React, { Component } from 'react';
import Slider from 'react-slick';
// import IntlMessages from "../../util/IntlMessages";
// import { BASE_URL } from "../../constants/Common";
import BannerImage from './BannerImage';

class DashboardSlider extends Component {
  render() {
    var settings = {
      dots: true,
      infinite: true,
      arrows: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    return (
      <div className="homeContainer">
        <Slider {...settings}>
          {this.props.images &&
            this.props.images.images &&
            this.props.images.images.length &&
            this.props.images.images.map((src) => {
              return (
                <div className="homeBanner1">
                  <div className="homeBanner1Img">
                    <BannerImage src={src} />
                  </div>
                </div>
              );
            })}
          {/* <div class="homeBanner1Conetnt">
              <h2>Match Pair Diamond</h2>
              <p>Lorem Ipsum is simply dummy text of</p>
              <a href="/">
                <IntlMessages id="app.showMore" />
              </a>
            </div> */}
          {/* <div class="homeBanner1 leftRightBlock">
            <div class="homeBanner1Conetnt leftBlock">
              <h2>PNShah Diamond</h2>
              <p>Lorem Ipsum is simply dummy text of</p>
              <a href="/">
                <IntlMessages id="app.showMore" />
              </a>
            </div>
            <div class="homeBanner1Img rightBlock">
              <img
                onError={() => {
                  this.setState({ second: require("../../assets/img/dashboard/silder1.jpg") });
                }}
                src={this.state.second}
                alt="banner"
              />
            </div>
          </div> */}
        </Slider>
      </div>
    );
  }
}
export default DashboardSlider;
